<template>
  <div style="text-align:center; width:600px;">
    <title>{{$t('userLimited.labels.title')}}</title>
    <p style="text-align:left;"><img src="../img/logo.gif" alt border="0"></p>
    <p style="background:#FF9999; color:#FFF; font-size:16px; font-weight:bold; margin:0; padding-top:8px; padding-bottom:8px; width:600px; text-align:center;" >アクセス集中のお知らせ</p>
    <div style="border:1px solid #aaa; margin-top:10px; width:600px;">
      <p style="color:#333; font-size:14px; font-weight:bold; padding-top:20px; margin:0;">{{$t('userLimited.labels.msg1')}}</p>
      <p style="color:#333; font-size:12px; padding-top:15px; margin:0;">{{$t('userLimited.labels.msg2')}}</p>
      <p style="color:#333; font-size:12px; padding-top:15px; margin:0;"></p>
      <p style="color:#333; font-size:12px; padding-top:15px; margin:0;"></p>
      <p style="font-size:14px; padding-top:15px; padding-bottom:20px; margin:0;">
        <i class="fas fa-angle-right"></i>&nbsp;
        <router-link :to="{name : SiteConstants.PG010MAIN , query: {pageNo: 1}}" style="color:#FF5555;">{{$t('userLimited.labels.link')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import SiteConstants from 'assets/const/SiteConstants.json';
export default {
  name: 'SorryPage',
  /*
  * Declare variable and set default value
  */
  data() {
      return {
          SiteConstants: SiteConstants,
          site: ""
      };
  },
  mounted: function() {
    var _this = this;
    _this.site = _this.$router.history.current.fullPath.split("/")[1];
  }
};
</script>

<style scoped>
</style>
